import { EXCLUIR_ITEM } from '../data/excluir-item'
import {
  ExcluirItemMutationMutation,
  ExcluirItemMutationMutationVariables,
  ItemBiblioteca
} from '@/core/types/graphql'
import { t } from '@lingui/core/macro'
import { useConfirmModal } from '@/core/context/confirm-modal-context'
import { request } from '../../../core/utils/request'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useRemover = ({ close }: { close: () => void }) => {
  const client = useQueryClient()

  const excluirItemMutation = useMutation({
    mutationKey: ['excluirItem'],
    mutationFn: async ({
      variables
    }: {
      variables: ExcluirItemMutationMutationVariables
    }) =>
      await request<
        ExcluirItemMutationMutation,
        ExcluirItemMutationMutationVariables
      >(EXCLUIR_ITEM, { variables }),
    onSuccess: async () => {
      await client.refetchQueries({ queryKey: ['itemsPorPasta'] })
      await client.refetchQueries({ queryKey: ['ultimosModificados'] })
      await client.refetchQueries({
        queryKey: ['ultimosModificadosExpanded']
      })
      await client.refetchQueries({ queryKey: ['buscaBibliotecaPaged'] })
      await client.refetchQueries({ queryKey: ['pastasPermissaoEscrita'] })
    }
  })

  const { askUser } = useConfirmModal()

  const handleRemover = async (itemsToRemove: ItemBiblioteca[]) => {
    const hasPasta = () => {
      if (itemsToRemove !== null && itemsToRemove.length > 0) {
        return (
          itemsToRemove.filter((item: ItemBiblioteca) => item.isPasta).length >
          0
        )
      }

      return false
    }

    askUser({
      onConfirm: async () => {
        await Promise.all(
          itemsToRemove.map((item: ItemBiblioteca) =>
            excluirItemMutation.mutateAsync({
              variables: {
                idItem: item.id
              }
            })
          )
        )

        close()
      },
      title: t`Você realmente deseja excluir?`,
      subtitle: hasPasta()
        ? t`Excluindo essa pasta você também irá excluir todos os itens filhos.`
        : undefined,
      confirmLabel: t`Excluir`,
      errorMessage: t`Erro ao remover`,
      successMessage: t`Remoção feita com sucesso!`
    })
  }

  return {
    handleRemover
  }
}
